import React, { Component } from "react";
import "./App.css";
import firebase from "firebase";
import Header from "./components/Header";
import GoogleAds from "./GoogleAds";
import TotalVotes from "./components/TotalVotes";
import BudgetVote from "./components/BudgetVote";
import Comment from "./components/Comment";
import Footer from "./components/Footer";
import FooterCredits from "./components/FooterCredits";

var firebaseConfig = {
  apiKey: "AIzaSyB0tATlNzZYEIK7iAyrHoQISwXsWPerBFw",
  authDomain: "budget-voting-poll.firebaseapp.com",
  databaseURL: "https://budget-voting-poll.firebaseio.com",
  projectId: "budget-voting-poll",
  storageBucket: "budget-voting-poll.appspot.com",
  messagingSenderId: "696737071712",
  appId: "1:696737071712:web:e457051c27bebc3edc3905"
};

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
const increment = firebase.firestore.FieldValue.increment(1);
const collection = "budget2020";

const CardsIcon01 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_01.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon02 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_02.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon04 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_04.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon05 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_05.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon06 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_06.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon07 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_07.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon08 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_08.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon09 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_09.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon10 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_10.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon11 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_11.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon12 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_12.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon13 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_13.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon14 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_14.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon15 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_15.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};
const CardsIcon16 = () => {
  return (
    <>
      <img src="https://pages.malaysiakini.com/budget2020/img/icon_poll_16.svg" className="uk-width-1-2" alt=" " />
    </>
  );
};

const voteQuest = [
  {
    id: "budget-2020-card-01",
    title: "主要城市调整最低薪金",
    descr: "2020年起，主要城市每月最低薪金从1100令吉增至1200令吉。",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon01 />
  },
  {
    id: "budget-2020-card-02",
    title: "产假增加",
    descr: "从2021年起，产假从60天增至90天。",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon02 />
  },
  {
    id: "budget-2020-card-04",
    title: "外国人置产门槛降低",
    descr: "为了减少公寓供应过剩，外国人购买房产门槛如今从100万令吉以上，降低至60万令吉以上。",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon04 />
  },
  {
    id: "budget-2020-card-05",
    title: "超级富豪需缴付更多税务",
    descr: "年收入200万令吉或以上的超级富豪，缴付的所得税从28%增至30%。",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon05 />
  },
  {
    id: "budget-2020-card-06",
    title: "数码服务如Netflix, Spotify需缴税",
    descr: "2020年1月1日起，政府将实施数码税。",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon06 />
  },
  {
    id: "budget-2020-card-07",
    title: "为找到工作的失业大学生提供奖掖",
    descr: "获得聘雇的失业大学生与雇主，将连续2年获得每月500令吉和300令吉的聘雇奖掖。",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon07 />
  },
  {
    id: "budget-2020-card-08",
    title: "提供免税发展数码经济",
    descr: "投资特定知识领域的电子电气公司可获得最长10年的所得税免税期。",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon08 />
  },
  {
    id: "budget-2020-card-09",
    title: "南北大道过路费降价",
    descr: "政府宣布南北大道过路费会平均降低18%，但仍未公布实行日期。",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon09 />
  },
  {
    id: "budget-2020-card-10",
    title: "资助孩童注射疫苗",
    descr: "6000万令吉拨款将用来为所有儿童注射肺炎球菌疫苗。此疫苗要价325令吉，并需注射两针。",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon10 />
  },
  {
    id: "budget-2020-card-11",
    title: "舒缓柔新长堤拥堵问题",
    descr: "政府将耗资8500万令吉提升关税、移民与检疫大厦（CIQ），及舒缓柔新长堤的车流量。",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon11 />
  },
  {
    id: "budget-2020-card-12",
    title: "吸引更多中资",
    descr: "投资吉隆坡投资机构（InvestKL）设立‘特别渠道’以吸引中国投资，以向美国投资数额看齐。",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon12 />
  },
  {
    id: "budget-2020-card-13",
    title: "RON95汽油津贴涵盖非BSH受惠者",
    descr: "只要符合条件，新汽油卡允许所有，包括不是生活援助金（BSH）受惠者购买100公升的RON95津贴汽油。",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon13 />
  },
  {
    id: "budget-2020-card-14",
    title: "福利援助扩大受惠对象，但数目维持不变",
    descr: "生活援助金（BSH）数额维持不变，但身障者和40岁以上，月入2000令吉以下的单身人士加入受惠范围。",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon14 />
  },
  {
    id: "budget-2020-card-15",
    title: "电子竞技拨款加倍",
    descr: "电子竞技拥有高发展潜能，拨款增至2000万令吉。",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon15 />
  },
  {
    id: "budget-2020-card-16",
    title: "特别开彩期减少",
    descr: "博彩公司的特别开彩期将从一年11次减至8次。",
    likes: "0",
    dislikes: "0",
    isVoted: false,
    icon: <CardsIcon16 />
  }
];

class App extends Component {
  constructor() {
    super();
    this.state = {
      voteCards: [],
      isLoading: true,
      isUserVoted: null,
      totalActionCount: 0,
      totalAverageLikesCount: 0,
      totalAverageDislikesCount: 0
    };
  }

  componentDidMount = async () => {
    (function() {
      let d = document,
        s = d.createElement("script");
      s.src = "https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-55378495366fd469";
      (d.head || d.body).appendChild(s);
    })();

    const clonedQuest = [...voteQuest];

    const newVoteQuest = clonedQuest.map(item => {
      const getLock = localStorage.getItem(`${item.id}-lock`);
      console.log(getLock);
      let isVoted = getLock === "1";
      console.log(isVoted);
      item.isVoted = isVoted;
      return item;
    });

    const allVotesDataPromise = [];

    newVoteQuest.map(item => {
      const newFetch = db
        .collection("budget2020")
        .doc(item.id)
        .get();
      allVotesDataPromise.push(newFetch);
      return null;
    });

    const allVotesDataSnapshots = await Promise.all(allVotesDataPromise);

    const allVotesData = {};
    newVoteQuest.map((item, index) => {
      allVotesData[item.id] = allVotesDataSnapshots[index].data();
      return null;
    });

    const finalVoteQuest = newVoteQuest.map(item => {
      const voteData = allVotesData[item.id];
      item.likes = voteData.likes || 0;
      item.dislikes = voteData.dislikes || 0;
      return item;
      // item.likes = voteData.likes || 0;
    });

    console.log(finalVoteQuest);

    this.setState({ voteCards: newVoteQuest, isLoading: false }, () => {
      this.calculateAllActions();
    });
  };

  calculateAllActions = () => {
    const { voteCards } = this.state;
    let actionCount = 0;
    let averageLikesCount = 0;
    let averageDislikesCount = 0;
    voteCards.map(item => {
      const { likes, dislikes } = item;
      const totalItemCount = likes + dislikes;
      actionCount = actionCount + totalItemCount;
      averageLikesCount = parseInt((likes / totalItemCount) * 100);
      averageDislikesCount = parseInt((dislikes / totalItemCount) * 100 + 1);
      return null;
    });

    this.setState({ totalActionCount: actionCount });
    this.setState({ totalAverageLikesCount: averageLikesCount });
    this.setState({ totalAverageDislikesCount: averageDislikesCount });
  };

  updateCurrentCounts = async () => {
    const clonedQuest = [...voteQuest];
    const allVotesDataPromise = [];

    clonedQuest.map(item => {
      const newFetch = db
        .collection("budget2020")
        .doc(item.id)
        .get();
      allVotesDataPromise.push(newFetch);
      return null;
    });

    const allVotesDataSnapshots = await Promise.all(allVotesDataPromise);

    const newClone = clonedQuest.map((item, index) => {
      const countForThisItem = allVotesDataSnapshots[index].data();
      item.likes = countForThisItem.likes;
      item.dislikes = countForThisItem.dislikes;
      return item;
    });

    this.setState({ voteQuest: newClone });
  };

  // voteCards = voteQuest[0];

  lockUser = itemId => {
    localStorage.setItem(`${itemId}-lock`, "1");
  };

  updateUserIsVoted = itemId => {
    const clonedVoteCards = [...this.state.voteCards];
    console.log(clonedVoteCards);
    const newVoteCards = clonedVoteCards.map(item => {
      if (item.id === itemId) {
        item.isVoted = true;
      }
      return item;
    });
    this.setState({ voteCards: newVoteCards }, () => {
      this.calculateAllActions();
    });
  };

  handleLikeEvent = async itemId => {
    try {
      await db
        .collection(collection)
        .doc(itemId)
        .update({ likes: increment });
      this.lockUser(itemId);
      this.updateUserIsVoted(itemId);
      this.updateCurrentCounts();
      console.log("DONE!");
    } catch (error) {
      console.log(error);
    }
  };

  handleDislikeEvent = async itemId => {
    try {
      await db
        .collection(collection)
        .doc(itemId)
        .update({ dislikes: increment });
      this.lockUser(itemId);
      this.updateUserIsVoted(itemId);
      this.updateCurrentCounts();
      console.log("DONE!");
    } catch (error) {
      console.log(error);
    }
  };

  handleEvent = voteCardId => {
    const updatedVoteQuest = this.state.voteCards.map(voteCards => {
      if (voteCards.id === voteCardId) {
        return Object.assign({}, voteCards, {
          votes: voteCards.votes + 1
        });
      } else {
        return voteCards;
      }
    });

    this.setState({
      members: updatedVoteQuest
    });
  };

  render() {
    return (
      <>
      <Header />
        <section className="uk-section uk-padding-remove-top">
          <div className="uk-container uk-container-small">
            <TotalVotes totalActionCount={this.state.totalActionCount} totalAverageLikesCount={this.state.totalAverageLikesCount} totalAverageDislikesCount={this.state.totalAverageDislikesCount} />
            <ul className="uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m uk-text-center uk-grid-match uk-grid" uk-height-match="target: > li > .uk-card > .uk-card-body" uk-grid=" ">
              {!this.state.isLoading &&
                this.state.voteCards.map(voteCard => (
                  <BudgetVote
                    key={voteCard.id}
                    id={voteCard.id}
                    title={voteCard.title}
                    descr={voteCard.descr}
                    likes={voteCard.likes}
                    dislikes={voteCard.dislikes}
                    onVoteLike={this.handleLikeEvent}
                    onVoteDislike={this.handleDislikeEvent}
                    isUserVoted={voteCard.isVoted}
                    icon={voteCard.icon}
                  />
                ))}
            </ul>
          </div>
          <div className="uk-container uk-flex uk-flex-center uk-margin-large uk-light">
            <div>
              <p className="uk-text-small uk-text-uppercase uk-margin-small" style={{ fontSize: "10px", letterSpacing: "2px" }}>
                广告
              </p>
              <div id="ad-slot"></div>
            </div>
            <GoogleAds />
          </div>
        </section>
        <Comment />
        <Footer />
        <FooterCredits />
      </>
    );
  }
}

export default App;
